import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./facebookPixel";

const FacebookRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(); 
  }, [location.pathname]);

  return null;
};

export default FacebookRouteTracker;
